var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 8.03485C2.22266 8.03485 4.22136 3.37122 8.88499 3.37122C9.71068 3.37122 10.4891 3.52059 11.2057 3.78246",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6393 5.49896C15.3003 6.41075 15.5473 8.03486 15.5473 8.03486C15.5473 8.03486 13.5486 12.6985 8.88499 12.6985C7.6288 12.6985 6.48547 12.3531 5.52271 11.7678",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8835 8.03486C10.8835 9.13871 9.98866 10.0336 8.88481 10.0336C8.45256 10.0336 8.05094 9.89923 7.71753 9.67195",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 1.66748L16.111 16.1115",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesoff);
export default __webpack_public_path__ + "static/media/eyesoff.0552abf0992907152bb22459aeee9b58.svg";
export { ForwardRef as ReactComponent };